import { XML_SUBMISSION } from '../types'

const INITIAL_STATE = {
  getXMLSubmission: [],
}

const xmlSubmissionReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case XML_SUBMISSION:
      return {
        ...state,
        getXMLSubmission: payload,
      }
    default:
      return state
  }
}

export default xmlSubmissionReducer
